// @ts-strict-ignore
import type { NodeEditorFormAdapter } from '../useNodeEditorForm';
import type { FormState } from './types';

export const outputAttributeExpressionFormAdapter: NodeEditorFormAdapter<FormState> = {
  getDefaultFormValues(action) {
    const { output: { jqFunction, useJq } } = action;
    return {
      jqFunction,
      useJq,
    };
  },
  mapFormDataToAction(data, sourceAction) {
    const { jqFunction, useJq } = data;
    return {
      ...sourceAction,
      output: {
        ...sourceAction.output,
        jqFunction,
        useJq,
      },
    };
  },
};
